"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  name: 'ModalApplicationDetails',
  props: {
    application: {
      type: Object,
      required: true
    }
  },
  methods: {
    getStatusType: function getStatusType(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'is-warning';
        }
      }
      var types = {
        'PENDING': 'is-light',
        'IN_PROGRESS': 'is-info',
        'PAUSED': 'is-danger',
        'FINISHED': 'is-success'
      };
      return types[status] || 'is-light';
    },
    getStatusLabel: function getStatusLabel(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'ATRASADO';
        }
      }
      var labels = {
        'PENDING': 'PENDENTE',
        'IN_PROGRESS': 'EM ANDAMENTO',
        'PAUSED': 'PAUSADO',
        'FINISHED': 'FINALIZADO'
      };
      return labels[status] || status;
    },
    getCategoryLabel: function getCategoryLabel(category) {
      var categoryMap = {
        'ADJUVANT': 'Adjuvante',
        'FERTILIZER': 'Fertilizante',
        'OIL': 'Óleo',
        'FUNGICIDE': 'Fungicida',
        'INSECTICIDE': 'Inseticida',
        'HERBICIDE': 'Herbicida',
        'FUNGICIDE_INSECTICIDE': 'Fungicida e Inseticida'
      };
      return categoryMap[category] || category;
    },
    formatDate: function formatDate(date) {
      return (0, _moment.default)(date).format('DD/MM/YYYY');
    },
    formatDosage: function formatDosage(product) {
      if (product.area) {
        return "".concat(product.dosage).concat(product.unit, "/ha");
      } else if (product.volume) {
        return "".concat(product.dosage).concat(product.unit, "/").concat(product.volume, "L");
      }
      return "".concat(product.dosage).concat(product.unit);
    }
  }
};